import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const opTime = (): dayjs.Dayjs => {
  return dayjs();
};

/**
 * Convert local time to UTC based on a specific timezone
 * @param date - Date to convert (dayjs, Date, string)
 * @param tz - Timezone (e.g., 'America/New_York', 'Asia/Seoul')
 * @returns Dayjs object converted to UTC
 *
 * @example
 * // Convert user-selected date to UTC based on location timezone
 * const utcDate = toUTCByTimezone(selectedDate, location.timezone);
 * const formatted = utcDate.format('YYYY-MM-DDTHH:mm:ss[Z]');
 */
export const toUTCByTimezone = (
  date: Dayjs | Date | string | null | undefined,
  tz: string | null | undefined,
): Dayjs | null => {
  if (!date) return null;

  const targetTz = tz || 'UTC';

  const dateStr = dayjs(date).format('YYYY-MM-DD HH:mm:ss');
  return dayjs.tz(dateStr, targetTz).utc();
};
/**
 * Convert UTC time to local time based on a specific timezone.
 * Falls back to the browser's/user's timezone if no tz is provided.
 * @param date - UTC date (dayjs, Date, string)
 * @param tz - Timezone (e.g., 'America/New_York', 'Asia/Seoul')
 * @returns Dayjs object converted to the specified timezone's local time
 */
export const toLocalByTimezone = (
  date: Dayjs | Date | string | null | undefined,
  tz: string | null | undefined,
): Dayjs | null => {
  if (!date) return null;

  const targetTz = tz || dayjs.tz.guess();

  return dayjs.utc(date).tz(targetTz);
};
